import { Button, Card, CardContent, Grid } from '@material-ui/core'
import { useState } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import EditReport from '../../Report/EditReport'

interface ReportSummaryProps {
  request: IRequest
  index: number
}

const ReportSummary = ({ request, index }: ReportSummaryProps) => {
  const [showEditReport, setShowEditReport] = useState(false)
  const { project } = useSelector((state: RootStateOrAny) => state.projectDetails)

  return (
    <>
      <Card className="summary-card">
        <div className="flex space-between header align-center">
          <strong>Contract {project.type} report requirements</strong>

          <Button color="primary" onClick={() => setShowEditReport(true)}>
            <span className="underline"> Edit</span>
          </Button>
        </div>

        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              Report type
            </Grid>

            <Grid item xs={9}>
              {request.report.reportType}
            </Grid>

            <Grid item xs={3}>
              Additional notes
            </Grid>

            <Grid item xs={9}>
              {request.report.comments}
            </Grid>

            <Grid item xs={3}>
              Files
            </Grid>
            <Grid item xs={9}>
              {request.report.files.map((file, index) => (
                <div key={index}>{file.name}</div>
              ))}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <ModalPopUp
        title="Edit report"
        variant="full"
        setShowModal={setShowEditReport}
        showModal={showEditReport}
      >
        <EditReport setShowEditReport={setShowEditReport} index={index} />
      </ModalPopUp>
    </>
  )
}

export default ReportSummary
